import $http from "../../axios-instance";


/**
 * Obtener los negocios por id y company_id.
 *
 * @param {*} business_id
 * @param {*} company_id
 */
export async function getBusinessByIdAndCompanyId({ commit }, { business_id, company_id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(
            `businesses/get-by-id-with-sub-businesses/${business_id}?company_id=${company_id}`
        );
        commit("setSubBusinesses", response.data.data.sub_businesses);
        commit("dashboard/load", false, { root: true });
    } catch (error) {
        commit("dashboard/load", false, { root: true });
    }
}
